import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const ITEMS = [
  "Line Production",
  "Commercial Films",
  "Regional Stories",
  "Creative Development",
  "SWA Writer Network",
];

export default function GoshtaMarquee() {
  return (
    <div
      data-testid="goshta-marquee"
      className="border-y border-white/10 bg-[#0a0a0a] py-6 md:py-8"
    >
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="mx-8 flex items-center gap-16">
            <span className="font-display text-3xl uppercase tracking-tight text-neutral-200 md:text-5xl">
              {item}
            </span>
            <Asterisk className="text-[#B79045]" size={28} />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
